import { useCallback, useEffect, useRef, useState } from "react";
import { Timer } from "@/components/Timer";
import { useCountdown } from "@/hooks/useCountdown";
import { typingStats } from "@/lib/scoring";

export const TypingItem = ({ part, item, onSubmit }) => {
  const [text, setText] = useState("");
  const textRef = useRef("");
  const startRef = useRef(Date.now());
  const doneRef = useRef(false);
  const areaRef = useRef(null);

  const submit = useCallback(() => {
    if (doneRef.current) return;
    doneRef.current = true;
    onSubmit({ text: textRef.current, elapsed: Math.min(part.time, (Date.now() - startRef.current) / 1000) });
  }, [onSubmit, part.time]);

  useEffect(() => { areaRef.current?.focus(); }, []);
  const left = useCountdown(part.time, true, submit);
  const elapsed = Math.max(part.time - left, 1);
  const s = typingStats(item.text, text, elapsed);

  return (
    <div className="space-y-5">
      <div className="flex items-start justify-between gap-4">
        <div className="grid grid-cols-2 gap-3 font-mono">
          <div className="rounded-lg bg-slate-100 px-4 py-2"><div className="text-[10px] uppercase tracking-widest text-slate-500">Live WPM</div><div data-testid="typing-live-wpm" className="text-2xl font-bold text-slate-900">{text ? s.wpm : 0}</div></div>
          <div className="rounded-lg bg-slate-100 px-4 py-2"><div className="text-[10px] uppercase tracking-widest text-slate-500">Accuracy</div><div data-testid="typing-live-accuracy" className="text-2xl font-bold text-slate-900">{text ? Math.round(s.accuracy * 100) : 100}%</div></div>
        </div>
        <Timer left={left} total={part.time} />
      </div>
      <p data-testid="typing-target" className="select-none rounded-xl bg-slate-50 p-5 font-mono text-[15px] leading-7">
        {item.text.split("").map((ch, i) => (
          <span key={i} className={i < text.length ? (text[i] === ch ? "text-emerald-700" : "bg-rose-200 text-rose-800") : i === text.length ? "border-b-2 border-indigo-600 text-slate-900" : "text-slate-500"}>{ch}</span>
        ))}
      </p>
      <textarea ref={areaRef} data-testid="typing-input" value={text} rows={5} spellCheck={false}
        onPaste={(e) => e.preventDefault()} onChange={(e) => { textRef.current = e.target.value; setText(e.target.value); }}
        className="w-full rounded-lg border border-slate-300 p-4 font-mono text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-indigo-500" placeholder="Start typing here…" />
      <button data-testid="item-submit-btn" onClick={submit} className="rounded-full bg-indigo-600 px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-indigo-700">Finish typing</button>
    </div>
  );
};
